import React from 'react';
import './css/services.css';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
    const { t } = useLanguage();
    
    const Services = [
        // Original Business Services
        { 
            id: 1, 
            icon: "fas fa-building", 
            name: t('services.mainlandCompany.name'), 
            desc: t('services.mainlandCompany.desc'),
            price: t('services.mainlandCompany.price')
        },
        { 
            id: 2, 
            icon: "fas fa-handshake", 
            name: t('services.freeZoneCompany.name'), 
            desc: t('services.freeZoneCompany.desc'),
            price: t('services.freeZoneCompany.price')
        },
        { id: 3, icon: "fas fa-landmark", name: t('services.proServices.name'), desc: t('services.proServices.desc') },
        { id: 4, icon: "fas fa-calculator", name: t('services.taxConsultancy.name'), desc: t('services.taxConsultancy.desc') },
        { id: 5, icon: "fas fa-chart-line", name: t('services.financialStatements.name'), desc: t('services.financialStatements.desc') },
        { id: 6, icon: "fas fa-certificate", name: t('services.documentAttestation.name'), desc: t('services.documentAttestation.desc') },
        
        // New Services with Icon Links
        { id: 7, icon: "fas fa-university", name: t('services.bankAccounts.name'), desc: t('services.bankAccounts.desc') },
        { id: 8, icon: "fas fa-passport", name: t('services.visaServices.name'), desc: t('services.visaServices.desc') },
        { id: 9, icon: "fas fa-bed", name: t('services.hotelBooking.name'), desc: t('services.hotelBooking.desc') },
        { id: 10, icon: "fas fa-plane", name: t('services.flightTickets.name'), desc: t('services.flightTickets.desc') },
        { 
            id: 11, 
            icon: "fas fa-globe", 
            name: t('services.websiteDevelopment.name'), 
            desc: t('services.websiteDevelopment.desc'),
            price: t('services.websiteDevelopment.price')
        },
        { 
            id: 12, 
            icon: "fas fa-mobile-alt", 
            name: t('services.mobileAppDevelopment.name'), 
            desc: t('services.mobileAppDevelopment.desc'),
            price: t('services.mobileAppDevelopment.price')
        },
    ];

  return (
    <section id="services-section" className='our-services'>
        <div className='container'>
            <div className='section-header'>
                <h1> {t('services.title')} </h1>
            </div>

            <div className='row'>
                {Services.map((service, index) => (
                    <div key={index} className='col-lg-4 col-md-4 col-sm-6 col-6'>
                        <div className='service'>
                            <i> <i className={service.icon}></i> </i>
                            <h1> {service.name} </h1>
                            <p> {service.desc} </p>
                            {service.price && (
                                <p className='service-price'>
                                    {t('services.startingFrom')} <span>{service.price}</span>
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            
            </div>
        </div>
    </section>
  )
}

export default Services
